import { useMutation } from "react-query";
import type { Paywall } from "@/react/types";
import { paywallCheckoutApi } from "@circle-react/api/paywallCheckoutApi";
import type { PreviewError } from "@circle-react/contexts/Paywalls/usePaywallCheckout";
import type { GetPreviewParametersReturn } from "../../helpers";
import type { CheckoutPreviewContext } from "../../types/CheckoutProps";
import { fetchMockedData } from "./fetchMockedData";

interface UsePreviewMutationProps {
  checkoutPreviewContext?: CheckoutPreviewContext;
  paywall: Paywall;
}

export const usePreviewMutation = ({
  checkoutPreviewContext,
  paywall,
}: UsePreviewMutationProps) => {
  const fetcher =
    checkoutPreviewContext && paywall
      ? fetchMockedData(paywall, checkoutPreviewContext)
      : (params: GetPreviewParametersReturn) =>
          paywallCheckoutApi.preview(params);

  return useMutation<any, PreviewError, any>(fetcher);
};
